import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: (email, password) => api.post('/auth/login', new URLSearchParams({ username: email, password })),
};

export const locomotorasService = {
  getAll: () => api.get('/locomotoras/'),
  getById: (id) => api.get(`/locomotoras/${id}`),
  update: (id, data) => api.patch(`/locomotoras/${id}`, data),
};

export const serviciosService = {
  crear: (data) => api.post('/servicios/', data),
  getAll: () => api.get('/servicios/'),
  getMios: () => api.get('/servicios/mis-servicios'),
  getById: (id) => api.get(`/servicios/${id}`),
};

export const adblueService = {
  getAll: () => api.get('/adblue/'),
  getByLocomotora: (id) => api.get(`/adblue/locomotora/${id}`),
  crear: (data) => api.post('/adblue/', data),
};

export const usuariosService = {
  getMe: () => api.get('/usuarios/me'),
  getAll: () => api.get('/usuarios/'),
};

export default api;

export const locomotorasServiceExt = {
  crear: (data) => api.post('/locomotoras/', data),
  baja: (id) => api.delete(`/locomotoras/${id}`),
};
